import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

function LoginScreen() {
    const [isVisible, setIsVisible] = useState(false);
    const [formData, setFormData] = useState({
        email: "",
        password: "",
    });
    const [isAdmin, setIsAdmin] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        // Component mount olduğunda animasyonu başlat
        setIsVisible(true);
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError("");

        try {
            // Proxy kullanarak sadece path kısmını kullanıyoruz
            const response = await fetch("/rest/User/Login", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email: formData.email,
                    password: formData.password,
                }),
            });

            const responseData = await response.json();
            console.log("Response status:", response.status);
            console.log("Response data:", responseData);

            // Hata kontrolü: statusCode 401 ise hata
            if (responseData.statusCode === 401) {
                throw new Error(
                    "Email veya şifre hatalı. Lütfen tekrar deneyin."
                );
            } else if (
                responseData.statusCode &&
                responseData.statusCode >= 500
            ) {
                throw new Error(
                    "Sunucu hatası. Lütfen daha sonra tekrar deneyin."
                );
            }

            // Başarılı giriş kontrolü - value ve token var mı?
            if (responseData.value && responseData.value.token) {
                console.log("Giriş başarılı:", responseData);
                console.log("Token:", responseData.value.token);

                // Token'ı localStorage'a kaydet
                localStorage.setItem("authToken", responseData.value.token);

                // Kullanıcı bilgilerini kaydet - value içindeki tüm kullanıcı bilgilerini kaydet
                const userInfo = {
                    id: responseData.value.id,
                    name: responseData.value.name,
                    surname: responseData.value.surname,
                    email: responseData.value.email,
                    username: responseData.value.username,
                    phoneNumber: responseData.value.phoneNumber,
                    userType: responseData.value.userType,
                    userGender: responseData.value.userGender,
                    isVerified: responseData.value.isVerified,
                };
                localStorage.setItem("user", JSON.stringify(userInfo));

                // Navbar'ın güncellenmesi için custom event dispatch et
                window.dispatchEvent(new Event("loginStatusChanged"));

                // Admin checkbox işaretliyse admin paneline yönlendir
                if (isAdmin) {
                    // userType kontrolü yap
                    if (responseData.value.userType === 2) {
                        // Admin yetkisi var - admin paneline yönlendir
                        window.location.href = "/admin";
                    } else {
                        // Admin yetkisi yok - hata mesajı göster
                        throw new Error(
                            "Bu hesabın admin paneline erişim yetkisi bulunmamaktadır."
                        );
                    }
                } else {
                    // Ana sayfaya yönlendir
                    window.location.href = "/";
                }
            } else {
                // Ne başarılı ne hata - beklenmeyen durum
                throw new Error(
                    "Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin."
                );
            }
        } catch (error) {
            console.error("Giriş hatası:", error);
            setError(error.message || "Giriş yapılırken bir hata oluştu");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-black">
            <div
                className="absolute inset-0 opacity-20 bg-cover bg-center"
                style={{ backgroundImage: `url(/images/hero-1.jpg)` }}
            ></div>
            <div
                className={`relative w-full max-w-md p-8 bg-white/10 backdrop-blur-xl rounded-2xl shadow-2xl border border-white/10 transition-all duration-700 transform ${
                    isVisible
                        ? "opacity-100 translate-y-0"
                        : "opacity-0 translate-y-12"
                }`}
            >
                {/* Üst Navigasyon Alanı */}
                <div className="absolute -top-12 left-0">
                    {/* Geri Dönüş Butonu */}
                    <Link
                        to="/"
                        className="text-white/60 hover:text-white flex items-center gap-2 transition-colors duration-300"
                    >
                        <svg
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M10 19l-7-7m0 0l7-7m-7 7h18"
                            />
                        </svg>
                        <span>Ana Sayfa</span>
                    </Link>
                </div>

                <div
                    className={`mb-8 text-center transition-all delay-300 duration-700 ${
                        isVisible ? "opacity-100" : "opacity-0"
                    }`}
                >
                    <Link
                        to="/"
                        className="text-2xl font-bold bg-gradient-to-r from-blue-400 to-blue-600 bg-clip-text text-transparent inline-flex items-center gap-2"
                    >
                        Cyprus Yacht Club
                        <span className="text-2xl">⛵</span>
                    </Link>
                    <p className="mt-2 text-white/60">
                        Premium yat kiralama deneyimi
                    </p>
                </div>

                {/* Hata Mesajı */}
                {error && (
                    <div className="mb-4 p-3 bg-red-500/20 border border-red-500/30 rounded-xl text-red-400 text-sm">
                        {error}
                    </div>
                )}

                <form
                    onSubmit={handleLogin}
                    className={`space-y-6 transition-all delay-500 duration-700 ${
                        isVisible ? "opacity-100" : "opacity-0"
                    }`}
                >
                    <div>
                        <label className="block text-sm font-medium text-white/80 mb-2">
                            Email
                        </label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-white/30 focus:outline-none focus:border-blue-500 transition-all duration-300"
                            placeholder="mail@example.com"
                            required
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-white/80 mb-2">
                            Şifre
                        </label>
                        <div className="relative">
                            <input
                                type={showPassword ? "text" : "password"}
                                name="password"
                                value={formData.password}
                                onChange={handleInputChange}
                                className="w-full px-4 py-3 pr-12 bg-white/5 border border-white/10 rounded-xl text-white placeholder-white/30 focus:outline-none focus:border-blue-500 transition-all duration-300"
                                placeholder="••••••••"
                                required
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                className="absolute right-3 top-1/2 -translate-y-1/2 text-white/40 hover:text-white/80 transition-all duration-300 p-1 rounded-lg hover:bg-white/5"
                            >
                                {showPassword ? (
                                    <svg
                                        className="w-5 h-5"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L12 12m-3.122-3.122l4.243 4.243M15 15l6 6m-6-6v.01M15 15l6-6m-6 6h.01"
                                        />
                                    </svg>
                                ) : (
                                    <svg
                                        className="w-5 h-5"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                                        />
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                                        />
                                    </svg>
                                )}
                            </button>
                        </div>
                    </div>

                    <div className="flex items-center justify-between text-sm">
                        <div className="flex items-center">
                            <input
                                type="checkbox"
                                className="w-4 h-4 bg-white/5 border border-white/10 rounded focus:ring-blue-500"
                            />
                            <label className="ml-2 text-white/60">
                                Beni hatırla
                            </label>
                        </div>
                        <Link
                            to="/forgot-password"
                            className="text-blue-400 hover:text-blue-300 transition-colors"
                        >
                            Şifremi unuttum
                        </Link>
                    </div>

                    {/* Admin Checkbox */}
                    <div className="flex items-center p-3 bg-white/5 border border-white/10 rounded-xl hover:bg-white/10 transition-all duration-300 group w-full">
                        <div className="relative">
                            <input
                                type="checkbox"
                                id="adminCheckbox"
                                checked={isAdmin}
                                onChange={(e) => setIsAdmin(e.target.checked)}
                                className="sr-only"
                            />
                            <label
                                htmlFor="adminCheckbox"
                                className="flex items-center cursor-pointer"
                            >
                                <div
                                    className={`w-5 h-5 border-2 rounded-md transition-all duration-300 flex items-center justify-center ${
                                        isAdmin
                                            ? "bg-blue-500 border-blue-500 shadow-lg shadow-blue-500/30"
                                            : "bg-white/5 border-white/20 group-hover:border-white/40"
                                    }`}
                                >
                                    {isAdmin && (
                                        <svg
                                            className="w-3 h-3 text-white"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    )}
                                </div>
                                <span className="ml-3 text-white/80 font-medium group-hover:text-white transition-colors duration-300">
                                    Admin olarak giriş yap
                                </span>
                            </label>
                        </div>
                        {isAdmin && (
                            <div className="ml-auto">
                                <div className="flex items-center gap-1 text-blue-400 text-xs font-medium">
                                    <svg
                                        className="w-4 h-4"
                                        fill="currentColor"
                                        viewBox="0 0 20 20"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                    <span>Yönetici</span>
                                </div>
                            </div>
                        )}
                    </div>

                    <button
                        type="submit"
                        disabled={isLoading}
                        className="w-full py-3 px-4 bg-gradient-to-r from-blue-600 to-blue-500 text-white rounded-xl hover:shadow-lg hover:shadow-blue-500/30 transition-all duration-300 transform hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {isLoading ? (
                            <div className="flex items-center justify-center gap-2">
                                <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
                                Giriş yapılıyor...
                            </div>
                        ) : (
                            "Giriş Yap"
                        )}
                    </button>

                    <div className="text-center text-white/60">
                        Hesabınız yok mu?{" "}
                        <Link
                            to="/register"
                            className="text-blue-400 hover:text-blue-300 transition-colors"
                        >
                            Üye Ol
                        </Link>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default LoginScreen;
